<template>
  <div
    class="flex items-center gap-2 w-fit rounded-lg shadow px-4 relative"
    :class="[bgColor, borderColor]"
  >
    <div class="flex-1 flex items-center justify-center gap-2">
      <h2
        class="text-center py-2 flex items-center gap-2"
        :class="[textColor]"
        label="Primary"
        severity="primary"
      >
        {{ title }}
      </h2>
      <component v-if="icon" :is="icon" class="icon flex items-center" />
    </div>
    <div class="flex items-center gap-2">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    required: true,
  },
  icon: {
    type: Object,
    default: null,
  },
  bgColor: {
    type: String,
    default: "bg-[#25B0D7]",
  },
  borderColor: {
    type: String,
    default: "border border-[#25B0D7]",
  },
  textColor: {
    type: String,
    default: "text-white",
  }
});
</script>

<style scoped>
.bg-gradient {
  background-image: linear-gradient(to right, #385660, #49707E, #3A5762);
}
</style>
